import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderStateEnum } from '@modules/orders-module/enums/order-state.enum'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { OpenedOrdersComponent } from '@shared/components/trading/orders/orders-stocks/tables/opened-orders/opened-orders.component'
import { CanceledOrdersComponent } from '@shared/components/trading/orders/orders-stocks/tables/canceled-orders/canceled-orders.component'
import { FilledOrdersComponent } from '@shared/components/trading/orders/orders-stocks/tables/filled-orders/filled-orders.component'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'
import { AssetTypesComponent } from '@shared/components/common/asset-type/asset-type.component'

@UseLocales({ ru, en })
@Component({
	selector: 'app-orders-stocks',
	templateUrl: './orders-stocks.component.html',
	styleUrl: './orders-stocks.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslatePipe,
		OpenedOrdersComponent,
		CanceledOrdersComponent,
		FilledOrdersComponent,
		ButtonComponent,
		AssetTypesComponent,
	],
})
export class OrdersStocksComponent {
	protected readonly orderStateEnum = OrderStateEnum

	protected readonly ordersStatesTables: OrderStateEnum[] = [
		this.orderStateEnum.OPEN,
		this.orderStateEnum.CANCELED,
		this.orderStateEnum.FILLED,
	]

	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input.required<WidgetInterface<OrdersSettingsInterface> | null>()

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected activeOrderTable: Signal<OrderStateEnum> = computed((): OrderStateEnum => {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()
		if (!widget) return this.orderStateEnum.OPEN

		return widget.settings.stocks.activeState
	})
	protected setOrderState(state: OrderStateEnum): void {
		const widget: WidgetInterface<OrdersSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				stocks: {
					...widget.settings.stocks,
					activeState: state,
				},
			},
		})
	}
}
